import React from 'react';

const Payment = () => {
    return (
        <div>
            <h1>Payment is coming</h1>
        </div>
    );
};

export default Payment;